<div class="login-container" (submit)="login()">
  <h1 fxLayout="row" fxLayoutAlign="center center" class="dark-gray">{{ 'LOGIN.TITLE' | translate }}</h1>

  <form [formGroup]="loginForm">
    
    <label for="username">
      {{'LOGIN.USERNAME' | translate}}
    </label>
    <input id="username" type="text" formControlName="username">

    <label for="password">
      {{'LOGIN.PASSWORD' | translate}}
    </label>
    <input id="password" type="password" formControlName="password">

    <button class="button main-button" type="submit" [disabled]="!loginForm.valid">Login</button>
  </form>
  
  <div fxLayout="row" fxLayoutAlign="center center" class="white-background">
    <img src="assets/images/parts/bottom-shadow.png" />
  </div>

  <!-- social -->
  <div class="social-container">
    <p>{{ 'LOGIN.SOCIAL.DESCRIPTION' | translate }}</p>

    <div fxLayout="row">
      <a href=""><img src="assets/images/social/facebook.png"/></a>
      
      <a href=""><img src="assets/images/social/google.png"/></a>
    </div>

  </div>

</div>